angular.module('picmonicng').factory('CommentsResource', [
  '$resource',
  function ($resource) {
    return $resource(
      '/api/v3/comments/:comment_id/:resource/:resource_id',
      { comment_id: '@comment_id', resource: '@resource' },
      {
        update: { method: 'PUT', isArray: false },
      }
    );
  },
]);
